import { cx } from '@linaria/core';
import { pm2ConfigStore } from '@pm2/store';
import { RoundedTopGraphic, RoundedBottomGraphic, WavesGraphic, BubblesGraphic } from '@ui/kit';
import { svg } from './atom.relief-svg.style.js';
import { jsx } from 'react/jsx-runtime';

function ReliefSVG(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  switch (audience) {
    case "Grade1To3":
      return /*#__PURE__*/jsx(BubblesGraphic, {
        className: cx(props.className, svg, "fill", "bubbles"),
        width: "100%"
        // make sure height on svg's doesn't grow higher than content on
        // very wide viewports
        ,
        style: {
          maxHeight: 100
        },
        preserveAspectRatio: "none"
      });
    case "Grade4To6":
      return /*#__PURE__*/jsx(WavesGraphic, {
        className: cx(props.className, svg, "fill", "waves"),
        width: "100%",
        style: {
          maxHeight: 87
        },
        preserveAspectRatio: "none"
      });
    default:
      {
        const Comp = props.position === "top" ? RoundedTopGraphic : RoundedBottomGraphic;
        return /*#__PURE__*/jsx(Comp, {
          className: cx(props.className, svg, "rounded"),
          width: "100%",
          style: {
            maxHeight: 49
          },
          preserveAspectRatio: "none"
        });
      }
  }
}

export { ReliefSVG };
//# sourceMappingURL=atom.relief-svg.js.map
